import { api } from './requestGraphql.js';

const getLidInfo = async (lid, version) => {
    try {
        const res = await api.post(
            '',
            {
                query: `
          {
            getLidInfo(lid: "${lid}", version: "${version}") {
              id
              affiliate_id
              lid
              campaign_id
              offer_id
              landing_page
              landing_page_id
              date_added
              click
              landing_page_id_origin
              affiliate_name
              campaign_name
              cap_override_offer_id
              verticals 
              conversion_type
              payout_percent
              is_cpm_option_enabled
              os
              device
              advertiser_id
              platform
              geo
              isp
              affiliate_manager_id
              advertiser_manager_id
              origin_advertiser_id
              origin_conversion_type
              origin_is_cpm_option_enabled
              origin_offer_id
              origin_vertical_id
              payout
              payin
              referer
              fingerprint
              offer_name
              offer_description
              offer_type
              vertical_name
              is_unique_visit
              sub_campaign
              cid
              event
              sub_campaign_id
              domain
              affiliate_type
              true_affiliate_id
              program_id
              custom
              img
              kw
              s1
              s2
              s3
              s4
              s5
              s6
              s7
              redirect_url
              ip
              state
            }
          }
        `,
            }
        );
        const response = res.data.data.getLidInfo;
        // console.log(response)
        // console.log(`getLidInfo response count:`, response.length);
        return response;
    } catch (e) {
        console.log(e);
    }
};

export default {
    getLidInfo,
}